import React, { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Textarea } from '../TextArea';
import FormHelperText from '@material-ui/core/FormHelperText';

export const TextAreaAdapter: FC<FieldRenderProps<string, HTMLElement>> = ({
  input: { name, onChange, value },
  meta,
  ...rest
}) => {
  const showError =
    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) && meta.touched;

  return (
    <div>
      <Textarea
        {...rest}
        name={name}
        onChange={onChange}
        value={value}
        maxRows={10}
        error={showError}
      />
      {showError && <FormHelperText error>{meta.error || meta.submitError}</FormHelperText>}
    </div>
  );
};
